var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclamation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 60.938a28.437 28.437 0 110-56.875 28.437 28.437 0 010 56.874zm0 4.062a32.5 32.5 0 100-65 32.5 32.5 0 000 65z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51.66a6.086 6.086 0 013.762-5.626 6.096 6.096 0 018.425 5.626 6.088 6.088 0 01-6.093 6.09A6.096 6.096 0 0127 51.66zm.597-36.57a5.506 5.506 0 013.24-5.613 5.518 5.518 0 017.49 3.333c.239.735.32 1.512.239 2.28l-2.133 21.357a3.36 3.36 0 01-3.351 3.076 3.365 3.365 0 01-3.352-3.076L27.597 15.09z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default ForwardRef;